// extracted by mini-css-extract-plugin
module.exports = {"container":"Style_container__2GT37","primary":"Style_primary__1b015","secondary":"Style_secondary__gjHgr"};